/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : NewConfiguration.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : New Page component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         :  December 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            : <Author>
 * On            : <Date>
 * Description   : <Description>
 ******************************************************************************/

import React, { FC } from "react";
import { useSelector } from "react-redux";
import { selectCurrentWorkFlowStep } from "stores/ApmWorkFlowStore";
import {
  selectDiscardChangesWarning,
  selectSettingsResetWarning,
} from "stores/UIStore";
import { FormStepper } from "components/FormStepper";
import { GeneralInfo } from "components/GeneralInfo";
import { SelectAPMFile } from "components/SelectAPMFile";
import { APMSettings } from "components/APMSettings";
import { AircraftDetailsWrapper } from "components/AircraftDetails";
import { DiscardChangesWarningModal } from "components/DiscardChangesWarningModal";
import { SettingsResetWarningModal } from "components/SettingsResetWarningModal";
import "./CreateNewApm.scss";

export const CreateNewApm: FC = () => {
  const currentStep = useSelector(selectCurrentWorkFlowStep);
  const discardChangesWarning = useSelector(selectDiscardChangesWarning);
  const settingsResetWarning = useSelector(selectSettingsResetWarning);

  return (
    <div className="new-configuration">
      <div className="new-apm-label">Create APM Settings File </div>
      <FormStepper currentStep={currentStep} />
      {currentStep === 1 && <GeneralInfo />}
      {currentStep === 2 && <SelectAPMFile />}
      {currentStep === 3 && <AircraftDetailsWrapper />}
      {currentStep === 4 && <APMSettings />}
      {discardChangesWarning.showWarningModal && <DiscardChangesWarningModal />}
      {settingsResetWarning.showSettingsResetWarningModal && (
        <SettingsResetWarningModal />
      )}
    </div>
  );
};
